import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JornadaServicoService {

  constructor(private http: HttpClient) {}

  iniciarJornadaServicoOffline(payload: any): Promise<any> {
    return firstValueFrom(
      this.http.post(`/jornada-servico/iniciar-offline`, payload)
    );
  }

  finalizarJornadaServicoOffline(payload: any): Promise<any> {
    return firstValueFrom(
      this.http.post(`/jornada-servico/finalizar-offline`, payload)
    );
  }
}
